import React, {useEffect, useState} from "react";
import { Button, Col, Drawer, Input, Row, Space, Table, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import InputMask from "react-input-mask";
import { ApiCuratorService } from "../../../../../shared/api";
import { config } from '../../../../../shared/config/config';
import { countText, SectionToolbar, useSectionSearch } from "../../components/SectionToolbar/SectionToolbar";
import { useCanEdit } from "../../../sectionAccess";

const curatorFields = [
  {
    id: 1,
    placeholder: 'Фамилия куратора',
    field: 'lastName',
  },
  {
    id: 2,
    placeholder: 'Имя куратора',
    field: 'name',
  },
  {
    id: 3,
    placeholder: 'Отчество куратора',
    field: 'patronymic',
  },
  {
    id: 4,
    placeholder: 'Почта куратора',
    field: 'email',
  },
  {
    id: 5,
    placeholder: 'Телефон куратора',
    field: 'phone',
    mask: '+7 (999) 999-99-99'
  },
]

const initialCuratorInfo = {
  name: '',
  lastName: '',
  patronymic: '',
  phone: '',
  email: ''
}

export const CuratorsSections = () => {
  const canEdit = useCanEdit()
  const [curatorsList, setCuratorsList] = useState([])
  const [curatorCardPicture, setCuratorCardPicture] = useState([])
  const [isOpenedDrawer, setIsOpenedDrawer] = useState(false)
  const [curatorInfo, setCuratorInfo] = useState({...initialCuratorInfo})
  const [editableCuratorId, setEditableCuratorId] = useState(null)
  const [search, setSearch, curators] = useSectionSearch(curatorsList, ['lastName', 'name', 'patronymic', 'phone', 'email'])

  const fetchCurators = () => {
    ApiCuratorService.fetchCurators().then((res) => {
      setCuratorsList(res.data)
    })
  }

  useEffect(() => {
    fetchCurators()
  }, [])

  const handleCuratorPictureUpload = (info) => {
    let fileList = [...info.fileList];
    setCuratorCardPicture(fileList);
  }

  const handleCreateCurator = async (e) => {
    e.preventDefault()
    const curatorWithoutImage = !curatorCardPicture.length
    if (curatorWithoutImage) {
      return alert ('Прикрепите фотографию к карточке куратора')
    }
    const formData = new FormData();
    Object.entries(curatorInfo).forEach( item => {
      const key = item[0]
      let value = item[1]

      const isEmptyValue = !value
      if (isEmptyValue) {
        return formData.append(`data[${key}]`, '');
      }

      if (key === 'phone') {
        value = value.replace(/\D/g,'');
      }

      formData.append(`data[${key}]`, value);
    })

    curatorCardPicture[0]?.originFileObj
      ? formData.append('file[photo]', curatorCardPicture[0].originFileObj)
      : formData.append('file[photo]', '')

    try {
      editableCuratorId
        ? await ApiCuratorService.updateCuratorInfo(editableCuratorId, formData)
        : await ApiCuratorService.createCurator(formData)

      alert(`Куратор ${curatorInfo.lastName} ${curatorInfo.name} ${curatorInfo.patronymic} успешно ${editableCuratorId ? 'изменен' : 'создан'}`)
      setTimeout(() => setIsOpenedDrawer(false), 500)
      fetchCurators()

    } catch(err) {
      alert('Упс, произошла ошибка')
      setTimeout(() => setIsOpenedDrawer(false), 500)
    }
  }

  const setEditableCurator = (id) => {
    const editableCurator = curatorsList.find( item => item.id === id)
    let editableCuratorObj
    Object.keys(editableCurator).forEach( key => {
      if (key in initialCuratorInfo) {
        editableCuratorObj = {...editableCuratorObj, [key]: editableCurator[key]}
      }
    })
    setCuratorInfo(editableCuratorObj)
    if (editableCurator.photo) {
      setCuratorCardPicture([{
        name: editableCurator.photo,
        url: `${config.API_HOST}/media/${editableCurator.photo}`,
      },])
    }
  }

  const curatorsTableColumns = [
    {
      title: 'ФИО',
      key: 'name',
      render: ({ name, lastName, patronymic}) => [lastName, name, patronymic].filter(Boolean).join(' ')
    },
    {
      title: 'Телефон',
      dataIndex: 'phone',
      key: 'phone',
      // 79061234567 -> +7 (906) 123-45-67
      render: (text) => {
        const d = String(text || '').replace(/\D/g, '')
        return d.length === 11 ? `+7 (${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7, 9)}-${d.slice(9)}` : text
      }
    },
    {
      title: 'Почта',
      dataIndex: 'email',
      key: 'email',
      render: (text) => text
    },
    canEdit && {
      title: 'Действия',
      key: 'actions',
      width: 260,
      render: ({ id, name, lastName, patronymic }) => (
        <Space size="small">
          <Button
            onClick={() => {
              setEditableCuratorId(id)
              setEditableCurator(id)
              setIsOpenedDrawer(true)
            }}
          >
            Изменить
          </Button>
          <Button
            danger
            onClick={() => {
              let isAgree = window.confirm(`Вы уверены что хотите удалить куратора ${lastName} ${name} ${patronymic}?`)
              if (isAgree) {
                ApiCuratorService.deleteCurator(id).then(() => fetchCurators())
              }
            }}
          >
            Удалить
          </Button>
        </Space>
      ),
    },
  ].filter(Boolean);
  return (
    <>
      <Table
        bordered={true}
        title={() => (
          <SectionToolbar
            search={search}
            onSearch={setSearch}
            placeholder='ФИО, телефон или почта'
            count={countText(curatorsList.length, curators.length, search)}
          >
            {canEdit && (
              <Button type="primary" icon={<PlusOutlined/>} onClick={() => setIsOpenedDrawer(true)}>
                Создать куратора
              </Button>
            )}
          </SectionToolbar>
        )}
        columns={curatorsTableColumns}
        dataSource={curators}
        locale={{emptyText: 'Ничего не нашлось'}}
        showHeader={true}
        rowKey="id"
        showSorterTooltip={false}
      />
      <Drawer
        title={editableCuratorId ? 'Изменить информацию о кураторе' : 'Создать куратора'}
        width={720}
        onClose={() => {
          setIsOpenedDrawer(false)
          setCuratorInfo({...initialCuratorInfo})
          setEditableCuratorId(null)
          setCuratorCardPicture([])
        }}
        visible={isOpenedDrawer}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={() => setIsOpenedDrawer(false)} style={{marginRight: 8}}>
              Отменить
            </Button>
            <Button type="primary" htmlType="submit" form="createCurator" >
              {editableCuratorId ? 'Изменить' : 'Создать'}
            </Button>
          </div>
        }
      >
        <form id="createCurator" onSubmit={handleCreateCurator}>
          <Row gutter={16}>
            {curatorFields.map( ({placeholder, field, id, mask }) => (
              <Col span={12} style={{ marginBottom: '10px' }} key={id}>
                <div style={{ marginBottom: '10px' }}>{placeholder}</div>
                {mask
                  ? <InputMask value={curatorInfo[field]}  onChange={(e) => setCuratorInfo({...curatorInfo, [field]: e.target.value})} mask={mask}>
                    {inputProps => <Input {...inputProps} placeholder={placeholder} required />}
                  </InputMask>
                  : <Input
                    placeholder={placeholder}
                    required
                    value={curatorInfo[field]}
                    onChange={(e) => setCuratorInfo({...curatorInfo, [field]: e.target.value})}
                  />
                }
              </Col>
            ))}
            <Col span={24} style={{ marginBottom: '10px' }} >
              <Upload
                beforeUpload={() => false}
                listType="picture-card"
                fileList={curatorCardPicture}
                onChange={handleCuratorPictureUpload}
                showUploadList={{showPreviewIcon: false}}
              >
                {curatorCardPicture.length < 1 && 'Карточка куратора'}
              </Upload>
            </Col>
          </Row>
        </form>
      </Drawer>
    </>
  )
}
